import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTranslation } from 'next-i18next';
import React, { useMemo, useState } from 'react';
import { useAtom, useAtomValue } from 'jotai';
import {
  crashedTimeState,
  gameStatusState,
  noBetState,
  noNextRoundBetState,
} from '../state';
import { GameStatus } from '../types/crash';
import BetBtn from './BetBtn';
import { BetBoxContainer, StyledSwitchSection } from './styles';
import CrashBetAmount from './CrashBetAmount';
import CrashStopAtAmount from '@/components/features/casino/crash/BetBox/CrashStopAtAmount';
import AutoBet from '@/components/features/casino/crash/BetBox/AutoBet';
import useDisableInput from '@/components/features/casino/crash/BetBox/useDisableInput';

const BetBox: React.FC = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isPc = useMediaQuery(theme.breakpoints.up('md'));
  const DEFAULT_BET_AMOUNT = 1;
  const DEFAULT_STOP_AT = null;
  const [betAmount, setBetAmount] = useState(DEFAULT_BET_AMOUNT);
  const [stopAt, setStopAt] = useState(DEFAULT_STOP_AT);
  const disabled = useDisableInput();

  return (
    <BetBoxContainer>
      {!isPc ? (
        <BetBtn betAmount={betAmount} stopAt={stopAt} isPc={isPc} />
      ) : null}
      <CrashBetAmount
        disabled={disabled}
        defaultAmount={DEFAULT_BET_AMOUNT}
        onBetAmountChange={(amount) => setBetAmount(amount)}
        ssx={{
          flex: 1,
        }}
      />
      <CrashStopAtAmount
        defaultAmount={DEFAULT_STOP_AT}
        onChange={(amount) => setStopAt(amount)}
      />
      <StyledSwitchSection>
        {isPc ? <AutoBet /> : null}
        {isPc ? (
          <BetBtn betAmount={betAmount} stopAt={stopAt} isPc={isPc} />
        ) : null}
        {isPc ? null : <AutoBet sx={{ mt: 1 }} />}
      </StyledSwitchSection>
    </BetBoxContainer>
  );
};
export default BetBox;
